import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";

export enum BrokerRoutes {
    DASHBOARD = "/broker/dashboard",
    COMMISSIONS = "/broker/commissions",
    SUBSCRIPTION = "/broker/subscription",
    CRM = "/broker/crm",
}

const DashboardPage = lazy(() => import("./component/core/Dashboard/Dashboard"));
const CommissionsPage = lazy(() => import("./component/core/Commissions/Commissions"));
const SubscriptionPage = lazy(() => import("./component/core/Subscription/Subscription"));
const CrmPage = lazy(() => import("module/crm/CrmPage"));

export const BrokerRouter = (
    <>
        <Route path={BrokerRoutes.DASHBOARD} element={<DashboardPage />} />
        <Route path={BrokerRoutes.COMMISSIONS} element={<CommissionsPage />} />
        <Route path={BrokerRoutes.SUBSCRIPTION} element={<SubscriptionPage />} />
        <Route path={BrokerRoutes.CRM} element={<CrmPage />} />
        {/* Old standalone WA routes → redirect to CRM (WhatsApp tab) */}
        <Route path="/broker/whatsapp-settings" element={<Navigate to={BrokerRoutes.CRM} replace />} />
        <Route path="/broker/whatsapp/templates" element={<Navigate to={BrokerRoutes.CRM} replace />} />
    </>
);
